import { create } from "zustand"

import { ChildPasscodeStep } from "../../../../types"

interface ChildPasscodeModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
  step: ChildPasscodeStep
  setStep: (step: ChildPasscodeStep) => void
  passcode: string
  setPasscode: (passcode: string) => void
  confirmPasscode: string
  setConfirmPasscode: (confirmPasscode: string) => void
  showError: boolean
  setShowError: (showError: boolean) => void
}

export const useChildPasscodeModalStore = create<ChildPasscodeModalStore>(
  (set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () =>
      set({
        isOpen: false,
        step: ChildPasscodeStep.SET_PASSCODE,
        passcode: "",
        confirmPasscode: "",
        showError: false,
      }),
    step: ChildPasscodeStep.SET_PASSCODE,
    setStep: (step: ChildPasscodeStep) => set({ step }),
    passcode: "",
    setPasscode: (passcode: string) => set({ passcode }),
    confirmPasscode: "",
    setConfirmPasscode: (confirmPasscode: string) => set({ confirmPasscode }),
    showError: false,
    setShowError: (showError: boolean) => set({ showError }),
  })
)
